import { Box } from "@mui/material"

export const AppScreens = () => {
  return <Box width="100%" bgcolor="#00000020" py={12} minHeight={500} sx={{ backgroundImage: "url(/media/images/screens.png)", backgroundAttachment: "fixed", backgroundRepeat: "no-repeat", backgroundSize: "cover" }}></Box>
}